import { axiosNode } from '../config/axiosConfig';
import { manejarErrorServicio } from '../utils/errorHandlerUtil';

const RUTA_BANCOS = 'bancos';

export default {
  async buscarTodos() {
    try {
      const response = await axiosNode.get(RUTA_BANCOS);
      return response.data;
    } catch (error) {
      return await manejarErrorServicio(error);
    }
  },
};
